import OnOffSwitchContainer from "app/components/React/OnOffSwitchContainer/OnOffSwitchContainer";
import { StyledSwitchContainer } from "app/pages/website-analysis/geography/StyledComponents";

type OnOffSwitchRegionalsContainerProps = {
    isRegionalEnabled: boolean;
    toggleRegionals: (isSelected: boolean) => void;
    onOffSwitchLabel: string;
};

const OnOffSwitchRegionalsContainer: React.FC<OnOffSwitchRegionalsContainerProps> = ({
    isRegionalEnabled,
    toggleRegionals,
    onOffSwitchLabel,
}) => {
    return (
        <StyledSwitchContainer>
            <OnOffSwitchContainer
                onToggle={toggleRegionals}
                isSelected={isRegionalEnabled}
            />
            <div>{onOffSwitchLabel}</div>
        </StyledSwitchContainer>
    );
};

export default OnOffSwitchRegionalsContainer;
